import { render, staticRenderFns } from "./BigFileAttachment.vue?vue&type=template&id=1cc02f63"
import script from "./BigFileAttachment.ts?vue&type=script&lang=ts&external"
export * from "./BigFileAttachment.ts?vue&type=script&lang=ts&external"
import style0 from "./BigFileAttachment.vue?vue&type=style&index=0&id=1cc02f63&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports